<template>
    <div class="">

        <h5 class="info-head">上传承诺函<span v-if="!basicIsShow" style="margin-left:12px;color:red;font-weight:normal;">(存在入库审批中的专业类别,无法修改)</span></h5>
        <table border strip class="info-table">
            <tr>
                <th style="width: 30%">类型</th>
                <th style="width: 70%"><b>*</b>承诺函名称</th>
            </tr>
            <tr>
                <td>使用承诺函</td>
                <td>
                    <div v-for="file in gysfjs" :key="file.id">
                        <a v-if="file.sort == 1" 
                        :href="'/rest/file/down?fileName=' + file.fileName + '&fileOldName=' + encodeURIComponent(file.fileOldName)">
                            {{file.fileOldName}}
                        </a>
                    </div>
                </td>
            </tr>
            <tr>
                <td>投标承诺函</td>
                <td>
                    <div v-for="file in gysfjs" :key="file.id">
                        <a v-if="file.sort == 2"
                        :href="'/rest/file/down?fileName=' + file.fileName + '&fileOldName=' + encodeURIComponent(file.fileOldName)">
                            {{file.fileOldName}}
                        </a>
                    </div>
                </td>
            </tr>
        </table>
        <div class="splitter"></div>
        <div>
            <el-button icon="el-icon-plus" @click="addGysfj(1)">使用承诺函</el-button>
            <div style="display: inline-block;margin-left: 20px; font-size: 14px;">模版下载：<a :href="utilBaseUrl +'pc/static/registrationLetter.docx'" target="_blank" style="color:#F28619;">《大华供应商门户注册及使用承诺函》模板</a></div>
        </div>
        <div class="splitter"></div>
        <div>
            <el-button icon="el-icon-plus" @click="addGysfj(2)">投标承诺函</el-button>
            <div style="display: inline-block;margin-left: 20px; font-size: 14px;">模版下载：<a :href="utilBaseUrl +'pc/static/inviteLetter.doc'" target="_blank" style="color:#F28619;">《大华供应商门户投标承诺函》模板</a></div>
        </div>
        <div class="splitter"></div>
        <div class="text-center">
            <el-button v-if="basicIsShow"  :disabled="isSubmit" type="primary" @click="submit">提交</el-button>
        </div>
        <el-dialog title="上传承诺函" :visible.sync="gysfjVisible">
		            <el-form :model="gysfj" label-width="100px" :rules="rulesGysfj" ref="gysfjForm" class="supplier-form">
		                <el-form-item label="附件：" prop="baseFiles">
		                    <el-upload class="upload" ref="fileup"
		                               :action="uploadApi"
		                               :on-success="handleChangeGysfj"
		                               :on-error="uploadError"
		                               :on-preview="handlePreview"
		                               :on-remove="handleRemoveGysfj"
		                               :before-remove="beforeRemove"
		                               :before-upload="beforeUpload"
                                       :multiple="false"
		                               :limit="1"
		                               :on-exceed="handleExceed"
		                               :file-list="gysfj.baseFiles">
		                        <el-button size="small" type="primary">点击上传</el-button>
                                <div slot="tip" class="el-upload__tip">上传附件大小请不要超过100M。<br>
                                    <span class="redTip">注意：附件上传出现绿色打勾标志，才表示上传成功。</span></div>
		                    </el-upload>
		                </el-form-item>
		            </el-form>
		            <div slot="footer" class="dialog-footer">
		                <el-button @click="gysfjVisible = false">取 消</el-button>
		                <el-button type="primary" @click="submitGysfjList">确 定</el-button>
		            </div>
		        </el-dialog>
    </div>
</template>

<script type="text/babel">
    import util from '@/util'
    import { mapGetters, mapActions, mapMutations } from 'vuex'
    import { ADD_MANAGER, EDIT_MANAGER, REMOVE_MANAGER } from '@/store/mutation-types'
    import apis from '@/store/apis'
    import { managerRules,gysfjRules } from '@/util/rules'

    export default {
        name: 'supplier-gysfj',
        data () {
            return {
                rules: managerRules,
                gysfjVisible:false,
                rulesGysfj:gysfjRules,
                gysfj:{
                	baseFiles:[]
                },
            	utilBaseUrl: util.baseUrl.replace(':9007',':11020'),
            	baseUrl: util.baseUrl,
                uploadApi: `${util.baseUrl}rest/file/upload`,
                isSubmit:false,
                editIndex:void(0),
                fileSort: 1,
                basicIsShow: true  // 判断信息是否修改
            }
        },
        computed:mapGetters(['gysfjs']),
        methods: {
            ...mapActions(['addOrEditGysf','getGysfjs','submitGysfj']),
            ...mapMutations({addManager:ADD_MANAGER,editManager:EDIT_MANAGER,delManager:REMOVE_MANAGER}),
            addGysfj (sort) {
                this.fileSort = sort
                this.gysfjVisible=true;
                
                if (this.$refs.fileup) {
                    this.$refs.fileup.clearFiles()
                }

                this.$nextTick(()=>{
                    this.$refs.gysfjForm.resetFields()
                })

                this.gysfj.baseFiles = []

            },
            submitGysfjList(){
                this.$refs.gysfjForm.validate((valid) => {
                    if (valid) {
                        let tempFiles = this.gysfj.baseFiles
                        if (tempFiles.length > 0) {
                            if (!this.gysfjs) {
                                this.gysfjs = []
                            }
                            // 是否替换标记
                            let instateFlag = false
                            // 需要遍历替换或者增加里面的附件
                            this.gysfjs.forEach((element, i) => {
                                if (this.fileSort == element.sort) {
                                    // 如果是同一个种类的
                                    this.gysfjs[i] = tempFiles[0]
                                    instateFlag = true
                                }
                            })

                            if (!instateFlag) {
                                this.gysfjs.push(tempFiles[0])
                            }

                            let payload = {gysfj:this.gysfjs, editIndex:this.editIndex}
                            this.addOrEditGysf( payload )
                        }
                        this.gysfjVisible = false
                    }
                })
            },
            submit(){
            	this.isSubmit=true;
                this.submitGysfj().then((res) => {
                    if(res.data.result){
                        this.$confirm(res.data.message||'操作成功！', '', {
                            confirmButtonText: '确定',
                            showCancelButton: false,
                            showClose: false,
                            type: 'success',
                            center: true
                        }).then(() => {
                        	this.isSubmit=false;
                            window.location.reload()
                        },() => {
                        	this.isSubmit=false;
                            window.location.reload()
                        })
                        window.sessionStorage.setItem(this.$route.name,'saved')
                    }else{
                    	this.isSubmit=false;
                        this.$alert(res.data.message)
                    }
                }, err => {
                	this.isSubmit=false;
                    this.$alert(err)
                })
            },
			handleChangeGysfj(file, fileList) {
                // if(file.status=='success'){
                file.basefiles[0].sort = this.fileSort
                // 直接存入就行了
                this.gysfj.baseFiles.push(__getBaseFiles__(file))
                // }
            },
            handleRemoveGysfj(file, fileList) {
                this.gysfj.baseFiles = this.gysfj.baseFiles.filter(function(f){
                    return f.uid !== file.uid
                });
            },
            handlePreview(file) {
                console.log(file);
            },
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件,请先删除之前的文件`);
            },
            beforeRemove(file) {
                return this.$confirm(`确定移除 ${ file.name }？`);
            },
            beforeUpload(file){
                if(!util.allowUpload(file.name)){
                    this.$alert(`支持的文件类型：${util.acceptFileTypes.join(' | ')}`,'文件类型不支持，已取消上传！',{ type: 'error' })
                    return false
                }
                return true
            },

            uploadError(){
                this.$message({message:'上传出错，请稍后再试。',type:'error'});
            },
            checkStatus(){
                return apis.getLittleStatus(this.$root.stockId,this.hasLittleStatus012,this.hasLittleStatus3)
            }
        },
        created(){
            this.$root.loading = true
            Promise.all([this.getGysfjs()]).then(r=>{
                this.$nextTick(function(){
                    this.$root.loading = false
                })
            }).catch(err=>this.$root.loading = false)
        },
        mounted(){
            this.basicIsShow = window.sessionStorage.getItem('basicIsShow')
        }
    }
    function __getBaseFiles__(file){
        // let f = file.response.basefiles[0]
        let f = file.basefiles[0]
        file.fileOldName = f.fileoldname
        file.fileName = f.filename
        file.filePath = f.filepath
        file.fileSize = f.filesize
        file.fileType = f.filetype
        file.sort = f.sort
        file.name = f.fileoldname
        return file
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/dsp/supplier/Gysfj.vue